import { VueQueryPlugin } from '@tanstack/vue-query'
import { createApp } from 'vue'

import App from '@/App.vue'
import i18n, { setLocale } from '@/i18n'
import dayjs from '@/plugins/dayjs'
import router from '@/router'
import stores from '@/stores'
import '@/i18n/validation'
import { useWait } from '@/services/wait'

import 'vue-sonner/style.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'flag-icons/css/flag-icons.min.css'
import '@/assets/fonts/inter/styles.css'
import '@/assets/fonts/material-symbols/styles.css'
import '@/assets/css/dashboard.css'
import '@/assets/css/auth.css'

await setLocale(window.localStorage.getItem('language') ?? navigator.language ?? import.meta.env.VITE_LOCALE ?? 'en').catch(() => setLocale('en'))

const app = createApp(App)
app.config.globalProperties.$wait = useWait()

app
  .use(stores)
  .use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
        mutations: { retry: 0 },
      },
    },
  })
  .use(dayjs)
  .use(i18n)
  .use(router)
  .mount('#app')
